import * as React from 'react';

import DegreePageHeaderBffProvider from 'bundles/composable-page-header-degree/providers/DegreePageHeaderBffProvider';

const DefaultDegreePageHeaderProvider = ({ children }: { children: React.ReactNode }) => {
  return <DegreePageHeaderBffProvider>{children}</DegreePageHeaderBffProvider>;
};

export default DefaultDegreePageHeaderProvider;
